import { Theme } from '@mui/material/styles';
import { Box, Tooltip, SxProps, Stack } from '@mui/material';
//
import { fileData, fileFormat, fileThumb } from './utils';
import DownloadButton from './DownloadButton';
import { getFileExtension } from 'src/utils/getFileExtension';

// ----------------------------------------------------------------------

type FileIconProps = {
  file: any | File | string;
  tooltip?: boolean;
  imageView?: boolean;
  onDownload?: VoidFunction;
  sx?: SxProps<Theme>;
  imgSx?: SxProps<Theme>;
};

export default function FileThumbnail({
  file,
  tooltip,
  imageView,
  onDownload,
  sx,
  imgSx,
}: FileIconProps) {
  const { name = '', url = '', preview = '', extension, path } = file;
  let renderContent;



  if (path && !extension) {
    const format = fileFormat(path.split('.')[1]);
    renderContent =
      format === 'image' && imageView ? (
        <Box
          component="img"
          src={preview}
          sx={{
            width: 1,
            height: 1,
            flexShrink: 0,
            objectFit: 'cover',
            ...imgSx,
          }}
        />
      ) : (
        <Box
          component="img"
          src={fileThumb(format as string)}
          sx={{
            width: 32,
            height: 32,
            flexShrink: 0,
            ...sx,
          }}
        />
      );
  } else if (!extension) {
    return (
      <Box
        component="img"
        src={fileThumb('folder' as string)}
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          ...sx,
        }}
      />
    );
  } else {
    // const format = extension ? fileFormat(extension) : fileFormat(getFileExtension(name) as string);
     const format = fileFormat(getFileExtension(name) as string);

    renderContent =
      format === 'image' && imageView ? (
        <Box
          component="img"
          src={preview}
          sx={{
            width: 1,
            height: 1,
            flexShrink: 0,
            objectFit: 'cover',
            ...imgSx,
          }}
        />
      ) : (
        <Box
          component="img"
          src={fileThumb(format as string)}
          sx={{
            width: 32,
            height: 32,
            flexShrink: 0,
            ...sx,
          }}
        />
      );
  }

  if (tooltip) {
    return (
      <Tooltip title={name}>
        <Stack
          flexShrink={0}
          component="span"
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 'fit-content',
            height: 'inherit',
          }}
        >
          {renderContent}
          {onDownload && <DownloadButton onDownload={onDownload} />}
        </Stack>
      </Tooltip>
    );
  }

  return (
    <>
      {renderContent}
      {onDownload && <DownloadButton onDownload={onDownload} />}
    </>
  );
}
